import ColorDisplay from "@/components/Color/ColorDisplay"

export const columns = [
  {
    header: "Name",
    accessorKey: "key",
  },
  {
    header: "Attribute",
    accessorKey: "attribute",
  },
]
